export default __webpack_public_path__ + "static/media/demo-hand.74348eac.png";